import { gql } from '@apollo/client';
export const GET_ALL_ORGS = gql`
  query getOrgs {
    get
      @rest(
        type: "orgs"
        path: "/Organizations/companies"
        endpoint: "organizations"
      ) {
      id
      market
      name
      created
    }
  }
`;

export const GET_ORG_ID = gql`
  query getOrg($id: String!) {
    getOrg(id: $id)
      @rest(
        method: "GET"
        type: "org"
        path: "/Organizations/{args.id}"
        endpoint: "organizations"
      ) {
      id
      market
      name
    }
  }
`;

export const MOVE_BINDER_TO_ORG = gql`
  mutation moveOrg($body: Body!) {
    moveOrg(body: $body)
      @rest(
        type: "org"
        method: "POST"
        bodyKey: "body"
        path: "/organizations/movebinder"
        endpoint: "admin"
      ) {
      organization
      organizationAdministrator
    }
  }
`;

export const GET_ALL_USERS = gql`
  query getUsers($query: String!) {
    get(query: $query)
      @rest(type: "users", path: "/admin/?{args.query}", endpoint: "users") {
      nextPage
      data {
        id
        email
        fullName
        firstName
        lastName
        lastUpdated
        company
        phone
        profilePicture
      }
      totalCount
    }
  }
`;

export const POST_ORGANIZATION = gql`
  mutation postOrg($type: String!) {
    post(input: $input)
      @rest(
        type: "Org"
        path: "/organizations/"
        endpoint: "admin"
        method: "POST"
      ) {
      organization
      organizationAdministrator
    }
  }
`;
export const IMPERSONATE = gql`
  mutation impersonate($type: String!) {
    post(input: $input)
      @rest(
        type: "Org"
        path: "/impersonate/"
        endpoint: "admin"
        method: "POST"
      ) {
      impersonationToken
    }
  }
`;

export const GET_ALL_BINDERS = gql`
  query getBinders {
    get @rest(type: "binders", path: "/", endpoint: "binder") {
      id
      name
      active
      type
      createdDate
      metadata
    }
  }
`;

export const BINDER_SEARCH = gql`
  query getBinders(
    $searchTerm: String!
    $pageNumber: Number!
    $pageSize: Number!
  ) {
    get(searchTerm: $searchTerm, pageNumber: $pageNumber, pageSize: $pageSize)
      @rest(
        type: "binders"
        path: "/bindersearch?searchTerm={args.searchTerm}&pageNumber={args.pageNumber}&pageSize={args.pageSize}"
        endpoint: "admin"
      ) {
      data
      totalCount
      pageCount
      pageSize
      pageNumber
    }
  }
`;

export const DELETED_BINDER_SEARCH = gql`
  query getDeletedBinders(
    $searchTerm: String!
    $pageNumber: Number!
    $pageSize: Number!
  ) {
    get(searchTerm: $searchTerm, pageNumber: $pageNumber, pageSize: $pageSize)
      @rest(
        type: "deletedbinders"
        path: "/deletedbinders?searchTerm={args.searchTerm}&pageNumber={args.pageNumber}&pageSize={args.pageSize}"
        endpoint: "binder"
      ) {
      data
      totalCount
      pageCount
      pageSize
      pageNumber
    }
  }
`;

export const RESTORE_DELETED_BINDER = gql`
  mutation restoreDeletedBinder(
    $binderId: String!
    $removeAllParticipantsFromBinder: Boolean!
    $body: Body!
  ) {
    restoreDeletedBinder(
      binderId: $binderId
      removeAllParticipantsFromBinder: $removeAllParticipantsFromBinder
      body: $body
    )
      @rest(
        type: "restorebinder"
        path: "/deleted/{args.binderId}/restore?removeAllParticipantsFromBinder={args.removeAllParticipantsFromBinder}"
        endpoint: "binder"
        method: "POST"
        bodyKey: "body"
      ) {
      binder
      participants
      mail
    }
  }
`;

export const GET_BINDER_ACTIVITIES_BY_TYPE = gql`
  query getBinderActivitiesByType(
    $binderId: String!
    $pageNumber: Number!
    $pageSize: Number!
    $body: Body!
  ) {
    get(
      binderId: $binderId
      pageNumber: $pageNumber
      pageSize: $pageSize
      body: $body
    )
      @rest(
        type: "activitiesByType"
        path: "/binders/{args.binderId}/all?pageNumber={args.pageNumber}&pageSize={args.pageSize}"
        endpoint: "activities"
        method: "POST"
        bodyKey: "body"
      ) {
      data
    }
  }
`;

export const TENDER_SEARCH = gql`
  query getTenders(
    $searchTerm: String!
    $pageNumber: Number!
    $pageSize: Number!
    $sortOrder: String!
    $sortProperty: String!
  ) {
    get(
      searchTerm: $searchTerm
      pageNumber: $pageNumber
      pageSize: $pageSize
      sortOrder: $sortOrder
      sortProperty: $sortProperty
    )
      @rest(
        type: "tenders"
        path: "/tenders/alltenants?searchTerm={args.searchTerm}&pageNumber={args.pageNumber}&pageSize={args.pageSize}&sortOrder={args.sortOrder}&sortProperty={args.sortProperty}"
        endpoint: "etendering"
      ) {
      data
      totalCount
      pageCount
      pageSize
      pageNumber
    }
  }
`;

export const GET_ALL_INSPECTION_TEMPLATE = gql`
  query getInspectionTemplates {
    get
      @rest(type: "inspectionTypes", path: "/types/", endpoint: "inspections") {
      data
    }
  }
`;

export const GET_ALL_INSPECTION_TYPES = gql`
  query getInspectionTypes {
    inspectionTypes
      @rest(
        type: "inspectiontype"
        path: "/types/all"
        endpoint: "inspections"
      ) {
      id
      name
      defaultInterval
      regulation
    }
  }
`;

export const GET_ISSUE_TEMPLATES = gql`
  query getissueTemplates {
    get @rest(type: "RemarkTemplate", path: "/templates", endpoint: "issues") {
      id
      name
      items
    }
  }
`;

export const GET_ALL_MARKETS = gql`
  query getMarkets {
    get @rest(type: "Market", path: "/Markets/", endpoint: "organizations") {
      id
      name
      country
    }
  }
`;

export const GET_ALL_CUSTOMERS = gql`
  query getCustomers {
    get
      @rest(type: "Customer", path: "/", endpoint: "organizations") {
      id
      name
      marketId
      market {
        id
        name
        country
      }
      salesforceAccountId
      created
    }
  }
`;

export const GET_CUSTOMER = gql`
  query getCustomer($customerId: String!) {
    getCustomer(customerId: $customerId)
      @rest(
        method: "GET"
        type: "Customer"
        path: "/{args.customerId}"
        endpoint: "organizations"
      ) {
      id
      name
      marketId
      market {
        id
        name
        country
      }
      salesforceAccountId
      created
    }
  }
`;

export const POST_CUSTOMER = gql`
  mutation postCustomer($body: Body!) {
    postCustomer(body: $body)
      @rest(
        type: "Customer"
        path: "/"
        endpoint: "organizations"
        method: "POST"
        bodyKey: "body"
      ) {
      id
      name
      market {
        id
        name
        country
      }
      salesforceAccountId
    }
  }
`;

export const PUT_CUSTOMER = gql`
  mutation putCustomer($customerId: String!, $body: Body!) {
    putCustomer(customerId: $customerId, body: $body)
      @rest(
        type: "Customer"
        path: "/{args.customerId}"
        endpoint: "organizations"
        method: "PUT"
        bodyKey: "body"
      ) {
      id
      name
      market {
        id
        name
        country
      }
      salesforceAccountId
    }
  }
`;

export const GET_CUSTOMER_ORGANIZATIONS = gql`
  query getCustomerOrganizations($customerId: String!) {
    getCustomerOrganizations(customerId: $customerId)
      @rest(
        method: "GET"
        type: "CustomerOrganizations"
        path: "/{args.customerId}/organizations"
        endpoint: "organizations"
      ) {
      id
      name
      created
      updated
      market {
        id
        name
      }
      externalCustomerId
      legacyOrganizationId
      customer {
        id
        name
      }
      organizationType
      currentUserRole
    }
  }
`;

export const GET_FACILITY_STRUCTURES = gql`
  query getFacilityStructures {
    get(facilityId: $facilityId)
      @rest(
        type: "facilitystructures"
        path: "/{args.facilityId}/structures"
        endpoint: "facilities"
      ) {
      id
    }
  }
`;

export const GET_ALL_ROLE_TYPES = gql`
  query getRoleTypes {
    get @rest(type: "roleTypes", path: "/roles/types", endpoint: "binder") {
      id
      metadataElementId
      name
      tenantSpecific
    }
  }
`;

export const GET_ROLE_BY_ID = gql`
  query getRoleById {
    get(id: $id)
      @rest(
        type: "roleType"
        path: "/roles?filterbyRoleTypeId={args.id}"
        endpoint: "binder"
      ) {
      id
      binderRoleType
      name
      metadataValueForThisRole
      tenantSpecific
    }
  }
`;

export const GET_TEMPLATE = gql`
  query template($templateId: String!) {
    template(templateId: $templateId)
      @rest(
        type: "Template"
        path: "/templates/{args.templateId}"
        endpoint: "binder"
      ) {
      id
      assignableRoleTypes
      name
      description
      binderType
      binderMetadataElements
      defaultColor
      colorLocked
      defaultLogo
      logoLocked
      participants
      tabs
      tenantSpecific
    }
  }
`;

export const GET_ALL_TEMPLATES = gql`
  query getGlobalBinderTemplates {
    get @rest(type: "binders", path: "/templates/global", endpoint: "binder") {
      id
      name
      binderType
      description
      logoLocked
      colorLocked
      defaultLogo
      defaultColor
      participants
      tenantSpecific
      templateDescription
    }
  }
`;


export const GET_ALL_WORKFLOW_GLOBAL_TEMPLATES = gql`
  query getGlobalWorkflowTemplates {
    get @rest(type: "GlobalWorkflowTemplates" ,path: "/workflowtemplate/global", endpoint: "issues") {
      id,
      name,
      issueTemplateId,
      metadata,
      stateSettings,
      filterOptions,
      contentGroupSettings,
      tenantSpecific,
      instructions,
      isRemoved,
      created,
      createdBy,
      lastUpdatedBy,
      updated,
      market,
      isVisible,
      useResponsible
    }
  }
`;

export const PUT_TEMPLATE_MUTATION = gql`
  mutation editTemplate($templateId: String!, $body: Body!) {
    putTemplate(body: $body, templateId: $templateId)
      @rest(
        type: "Binder"
        method: "PUT"
        bodyKey: "body"
        path: "/templates/global/{args.templateId}"
        endpoint: "binder"
      ) {
      id
      name
      description
      binderType
      binderMetadataElements
      defaultColor
      colorLocked
      defaultLogo
      logoLocked
      participants
    }
  }
`;

export const GET_TAB_TEMPLATES = gql`
  query tabTemplates($templateId: String!) {
    tabTemplates(templateId: $templateId)
      @rest(type: "Binder", path: "/templates/tabs", endpoint: "binder") {
      alwaysActive
      binderRoleType
      defaultActive
      groupByMetadataElementId
      id
      market
      metadataRequiredForUpload
      metadataUsedForFilter
      metadataUsedForDisplay
      name
      positionLocked
      securityContext
      settings
      shortName
      subtabSettings
      tenantSpecific
      translationKey
      type
      templateDescription
      templateTranslationKey
    }
  }
`;

export const GET_USERS = gql`
  query getUsers($filterQuery: String!) {
    get(filterQuery: $filterQuery)
      @rest(
        type: "users"
        path: "/?query={args.filterQuery}"
        endpoint: "users"
      ) {
      nextPage
      data {
        id
        email
        fullName
        lastUpdated
      }
    }
  }
`;

export const GET_ROLES_QUERY_GLOBAL = gql`
  query roles($filterbyRoleTypeId: String!, $includeDisabled: Boolean!) {
    get(
      filterbyRoleTypeId: $filterbyRoleTypeId
      includeDisabled: $includeDisabled
    )
      @rest(
        type: "role"
        path: "/roles/global/?filterbyRoleTypeId={args.filterbyRoleTypeId}&includeDisabled={args.includeDisabled}"
        endpoint: "binder"
      ) {
      binderRoleType
      active
      description
      metadataValueForThisRole
      tenantSpecific
      id
      name
    }
  }
`;

export const GET_ROLETYPES_QUERY = gql`
  query roles {
    get
      @rest(
        type: "roletypes"
        path: "/roles/global/types"
        endpoint: "binder"
      ) {
      id
      metadataElementId
      name
      tenantSpecific
    }
  }
`;

export const GET_ROLES_QUERY = gql`
  query roles(
    $filterbyRoleTypeId: String!
    $tenantId: String!
    $includeDisabled: Boolean!
  ) {
    get(
      filterbyRoleTypeId: $filterbyRoleTypeId
      tenantId: $tenantId
      includeDisabled: $includeDisabled
    )
      @rest(
        type: "role"
        path: "/roles?filterbyRoleTypeId={args.filterbyRoleTypeId}&includeDisabled={args.includeDisabled}"
        endpoint: "binder"
      ) {
      binderRoleType
      active
      description
      metadataValueForThisRole
      tenantSpecific
      id
      name
    }
  }
`;

export const GET_ALL_GLOBAL_INSPECTION_TEMPLATES = gql`
  query getInspectionTemplates {
    globalInspectionType
      @rest(
        type: "globalInspectionType"
        path: "/types/global"
        endpoint: "inspections"
      ) {
      id
      name
      description
      market
      inspectionInterval
      remindBeforeDueDate
      leniencyDocuments
      additionalDocuments
      inspectionCategory
      appCompatible
      propertyStructureCompatible
      showRecurrenceOptions
      showReminderOptions
      inspectionPlanResultSettings
      inspectionOccasionResultSettings
      contractor
      appType
      supervisorRole
      disabled
      setDefaultContractor
      defaultContractor,
      workflowTemplateId
      uniqueNumberCountOnOccasionLevel
    }
  }
`;

export const GET_GLOBAL_INSPECTION_CATEGORIES = gql`
  query getInspectionTypes($market: String!) {
    inspectionCategories(market: $market)
      @rest(
        type: "inspectiontype"
        path: "/categories/global/all?market={args.market}"
        endpoint: "inspections"
      ) {
      id
      name
      defaultInterval
      inspectionCategory
      regulation
    }
  }
`;

export const GET_USER_2FA = gql`
  query getUser2FA($userId: String!) {
    get(userId: $userId)
      @rest(
        type: "User2FA"
        path: "/{args.userId}/2fa"
        endpoint: "users2fa"
      ) {
      level
    }
  }
`;

export const DELETE_USER_2FA = gql`
  mutation deleteUser2FA($userId: String!) {
    delete(userId: $userId)
      @rest(
        type: "Delete2FA"
        path: "/{args.userId}/2fa"
        endpoint: "users"
        method: "DELETE"
      ) {
      NoResponse
    }
  }
`;

export const GET_USER_BLOCK = gql`
  query getEmailBounces($email: String!) {
    get(email: $email)
      @rest(
        type: "user"
        path: "/email/bounces?email={args.email}"
        endpoint: "admin"
      ) {
      id
      active
      createdDate
      description
    }
  }
`;

export const GET_SENT_EMAIL_MESSAGES = gql`
  query getSentmails($email: String!, $nrOfMessages: Number) {
    get(email: $email, nrOfMessages: $nrOfMessages)
      @rest(
        type: "user"
        path: "/email/messages?email={args.email}&count={args.nrOfMessages}"
        endpoint: "admin"
      ) {
      id
      delivered
      lastActivityDate
      recipientEmail
      status
      subject
    }
  }
`;

export const ADMIN_USERS_CSV = gql`
  query adminUsersCSV($filterQuery: String!) {
    adminUsersCSV(filterQuery: $filterQuery)
      @rest(
        type: "AdminUsersCSV"
        path: "/admin/?query={args.filterQuery}&pageNumber=1&pageSize=1000"
        endpoint: "csvadmin"
      )
  }
`;

export const UPDATE_WORKFLOW_TEMPLATE_HIDE = gql`
  mutation UpdateWorkflowTemplateHide($id: String!, $body: Any!) {
    updateWorkflowTemplateHide(id: $id, body: $body)
      @rest(
        type: "WorkflowTemplate"
        path: "/workflowTemplate/global/{args.id}/hide"
        method: "PUT"
        endpoint: "issues"
        bodyKey: "body"
      ) {
      id
      name
      tenantSpecific
      isVisible
    }
  }
`;

export const CREATE_ISSUE_TEMPLATE = gql`
  mutation CreateIssueTemplate($payload: Any!) {
    createIssueTemplate(payload: $payload)
      @rest(
        type: "IssueTemplateResponse"
        path: "/templates/global"
        method: "POST"
        endpoint: "issues"
        bodyKey: "payload"
      ) {
      id
      name
    }
  }
`;

export const CREATE_WORKFLOW_TEMPLATE = gql`
  mutation CreateWorkflowTemplate($payload: Any!) {
    createWorkflowTemplate(payload: $payload)
      @rest(
        type: "WorkflowTemplateResponse"
        path: "/workflowTemplate/global"
        method: "POST"
        endpoint: "issues"
        bodyKey: "payload"
      ) {
      id
      name
    }
  }
`;

export const GET_ISSUE_TEMPLATE = gql`
  query getIssueTemplate($id: String!) {
    getIssueTemplate(id: $id)
      @rest(
        method: "GET"
        type: "IssueTemplate"
        path: "/templates/global/{args.id}"
        endpoint: "issues"
      ) {
      id
      name
      flags
      locationOnDrawing,
      items
    }
  }
`;


export const GET_WORKFLOW_TEMPLATE = gql`
  query getWorkflowTemplate($id: String!) {
    getWorkflowTemplate(id: $id)
      @rest(
        method: "GET"
        type: "WorkflowTemplate"
        path: "/workflowTemplate/global/{args.id}"
        endpoint: "issues"
      ) {
      id
      name
      issueTemplateId,
      contentGroupSettings,
      created,
      createdBy,
      filterOptions,
      isRemoved,
      isVisible,
      lastUpdatedBy,
      market,
      stateSettings,
      states,
      tenantSpecific,
      updated,
      instructions,
      useResponsible
    }
  }
`;

export const UPDATE_WORKFLOW_TEMPLATE = gql`
  mutation UpdateWorkflowTemplate($id: String!, $body: Any!) {
    updateWorkflowTemplate(id: $id, body: $body)
      @rest(
        type: "WorkflowTemplate"
        path: "/workflowTemplate/global/{args.id}"
        method: "PUT"
        endpoint: "issues"
        bodyKey: "body"
      ) {
      id
      name
      tenantSpecific
      isVisible
    }
  }
`;

export const UPDATE_ISSUE_TEMPLATE = gql`
  mutation UpdateIssueTemplate($id: String!, $body: Any!) {
    updateIssueTemplate(id: $id, body: $body)
      @rest(
        type: "IssueTemplate"
        path: "/templates/global/{args.id}"
        method: "PUT"
        endpoint: "issues"
        bodyKey: "body"
      ) {
      id
      title
      description
      tenantSpecific
      isVisible
    }
  }
`;